import { render, staticRenderFns } from "./CollapseDivMain.vue?vue&type=template&id=28ee351b&scoped=true&"
import script from "./CollapseDivMain.vue?vue&type=script&lang=js&"
export * from "./CollapseDivMain.vue?vue&type=script&lang=js&"
import style1 from "./CollapseDivMain.vue?vue&type=style&index=1&id=28ee351b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee351b",
  null
  
)

export default component.exports